import React from "react";

export function SectionHeading({ eyebrow, title, description, align = "left", className = "" }) {
    const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
    return (
        <div className={`flex flex-col ${alignCls} gap-4 max-w-3xl ${align === "center" ? "mx-auto" : ""} ${className}`}>
            {title && (
                <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-foreground leading-[1.02]">
                    {title}
                </h2>
            )}
            {description && (
                <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl">
                    {description}
                </p>
            )}
        </div>
    );
}

export default SectionHeading;
